import { IApiError } from '@/models/apiError.model';
import { ISuggestedFaqDetails } from '@/models/suggestedFaq.model';

export const SLICE_NAME = 'suggestedFaqDetails';

export interface SuggestedFaqDetailsState {
  item: ISuggestedFaqDetails | null;
  isLoading: boolean;
  error: IApiError | null;
}

export const initialState: SuggestedFaqDetailsState = {
  item: null,
  isLoading: false,
  error: null,
};
